import { IconButton } from '@eventbrite/eds-icon-button';
import { PencilChunky } from '@eventbrite/eds-iconography';
import { InputField } from '@eventbrite/eds-input-field';
import { gettext } from '@eventbrite/i18n';
import PropTypes from 'prop-types';
import React from 'react';
import { ofuscateEmail } from '../../../utils/security';
import './StaticEmailField.scss';

const StaticEmailField = ({
    onEmailEdit,

    shouldRevealEmail,
    onEmailMismatch,

    errors,
    value,
    field,
}: {
    onEmailEdit?: () => void;
    onEmailMismatch?: () => void;

    shouldRevealEmail?: boolean;

    errors: any;
    value: string;
    field: any;
}) => {
    const _handleEmailEdit = () => {
        onEmailEdit?.();

        if (errors.confirmEmail) {
            onEmailMismatch?.();
        }
    };

    let editButton = null;

    if (!shouldRevealEmail) {
        value = ofuscateEmail({ email: value });
    }

    if (onEmailEdit) {
        editButton = (
            <IconButton
                iconType={<PencilChunky />}
                onClick={_handleEmailEdit}
                title={gettext('Edit Email')}
            />
        );
    }

    return (
        <div className="static-email-field__button">
            <InputField
                id="email"
                label={gettext('Email address')}
                suffix={editButton}
                placeholder={value}
                disabled={true}
                hasMinAsideSpacing={true}
                style="static"
                field={field}
            />
        </div>
    );
};

StaticEmailField.propTypes = {
    value: PropTypes.string.isRequired,
    onEmailEdit: PropTypes.func,
    clearNotification: PropTypes.func,
};

export default StaticEmailField;
